<template>
  <section class="container">
    <section class="input_box">
      <section v-for="item in sysPolicyTypeValues" :key="item.typeCode">
        <section class="list_box border-bottom" v-if="item.typeCode != 'policy_type_explain'">
          <section class="keyBox">
            <span class="list_key">{{item.typeName}}</span>
            <span class="red" v-if="item.isRequired">*</span>
          </section>
          <input class="list_val" v-model="item.typeValue" @blur="blur" :maxlength="item.strLen" :placeholder="'请输入'+item.typeName" />
        </section>
        <!-- 需求说明 -->
        <section class="requirement" v-if="item.typeCode == 'policy_type_explain'">
          <p>{{item.typeName}}<span class="red" v-if="item.isRequired">*</span></p>
          <textarea v-model="item.typeValue" placeholder="请简要陈述你对政策的服务需求，不超过200字" maxlength="200" resize="none"></textarea>
        </section>
      </section>
    </section>
    <section class="footer_h"></section>
    <section :class="['button',$store.state.common.theme==3?'footer_box_theme_3':'footer_box']" @click="comsultation">
      <p class="btn_default">提交</p>
    </section>
  </section>
</template>

<script>
import util from "../../utils/util";
import { getPolicyTypeByTypeCode,saveAdvices } from "../../utils/api";
import { mapState } from 'vuex';
export default {
  name: "policyServices",
  data() {
    return {
      data:{},
      userName:'',
      phone:'',
      email:'',
      company:'',
      sysPolicyTypeValues:[]
    };
  },
  computed:{
    ...mapState({
      common:state => state.common
    })
  },
  created(){
    if(this.common.userTenantInfo.id){
      this.userName = this.common.userTenantInfo.userName || '';
      this.email = this.common.userTenantInfo.email || '';
      this.company = this.common.userTenantInfo.company || '';
    }else{
      this.userName = this.common.userInfo.userName || ''
    }
    this.phone = this.common.userInfo.phone || this.common.userInfo.account || "";
    this.getPolicyTypeByTypeCode()
  },
  methods: {
    blur(){
      setTimeout(function(){
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    getPolicyTypeByTypeCode(){
      getPolicyTypeByTypeCode({typeCode:this.$route.params.typeId}).then(res=>{
        console.log(res)
        if(res.res.code === 10000 && res.body.PolicyType){
          this.data = res.body.PolicyType;
          let sysPolicyTypeValues = this.data.sysPolicyTypeValues;
          sysPolicyTypeValues.forEach(item => {
            item.typeValue = '';
            if(item.typeCode == 'policy_type_name'){
              item.typeValue = this.userName
            }
            if(item.typeCode == 'policy_type_tel'){
              item.typeValue = this.phone
            }
            if(item.typeCode == 'policy_type_company'){
              item.typeValue = this.company
            }
            if(item.typeCode == 'policy_type_email'){
              item.typeValue = this.email
            }
          })
          this.sysPolicyTypeValues = sysPolicyTypeValues;
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    comsultation(){
      let list = this.sysPolicyTypeValues;
      let isOk = true;
      list.forEach(item=>{
        if(item.isRequired == '1'){
          if(!item.typeValue){
            isOk = false;
            util.showToast('请输入'+item.typeName)
            return false;
          }
        }
        // if(item.typeCode == 'policy_type_tel'){
        //   if(item.typeValue.length !== 11 || item.typeValue.slice(0,1) != 1){
        //     isOk = false;
        //     util.showToast('请输入正确的'+item.typeName)
        //     return false;
        //   }
        // }
      })
      if(!isOk){return false}
      util.showLoading()
      let params = {
        cityId:this.common.marketInfo.cityId,
        userId:this.common.userId,
        marketId:this.common.marketInfo.id,
        marketName:this.common.marketInfo.marketName,
        policyTypeId:this.data.id,
        sysPolicyId:this.$route.params.id,
        userName:this.userName,
        PolicyValues:this.sysPolicyTypeValues
      }
      saveAdvices(params).then(res=>{
        console.log(res)
        if(res.res.code === 10000){
          util.hideLoading()
          util.showToast('提交成功')
          this.$router.replace('/myConsultation')
        }else{
          util.hideLoading()
          util.showToast(res.res.msg)
        }

      })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #eee;
}
.input_box {
  margin-bottom: 14px;
}
.list_box {
  .flex();
  height: 100px;
  align-items: center;
  // .borderB();
  padding-left: 30px;
  padding-right: 66px;
  position: relative;
  background-color: #fff;
}

.keyBox {
  flex-direction: row;
  min-width: 200px;
}

.list_key {
  font-size: 28px;
  color: #666;
  height: 100px;
  line-height: 100px;
}
.list_val{
  flex:1;
  height:1rem;
}
.red {
  // height: 100px;
  // line-height: 100px;
  color: red;
}
.white {
  color: #ffffff;
}
.requirement {
  background: #fff;
  padding: 28px 30px;
  margin-top:14px;
  p {
    font-size: 28px;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
    margin-bottom: 14px;
  }
  textarea{
    width:100%;
    height:200px;
  }
}
.footer_h{
  height:108px;
  width:100%;
}
.footer_box {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: 108px;
  padding:0 28px;
  box-sizing:border-box;
  .flex();
  align-items: center;
  justify-content: center;
  p {
    height: 76px;
    background: rgba(23, 64, 218, 1);
    border-radius: 4px;
    font-size: 32px;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 76px;
    display: block;
    width:100%;
    text-align: center;
  }
}
.footer_box_theme_3{
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: 108px;
  padding: 0 28px;
  background: #fff;
  box-sizing: border-box;
  .flex();
  align-items: center;
  justify-content: center;
  p {
    height: 76px;
    background: #A1805D;

    border-radius: 38px;
    font-size: 32px;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 76px;
    display: block;
    width: 100%;
    text-align: center;
  }
}
</style>